import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import type { IPageWillMountHandler } from '@wix/thunderbolt-symbols'
import { LifeCycle, ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { translationsService } from './translationsService'
import { translationsServicePageWillMount } from './translationsServicePageWillMount'

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(translationsService)
	bind<IPageWillMountHandler>(LifeCycle.PageWillMountHandler).to(translationsServicePageWillMount)
}
